import { instance } from "libs/api";

import { ContentPrivacyAndTerms } from "../../content.types";
import { ApiRoutesContent } from "./../../constants/enums";

export const requestGetPrivacyAndTerms =
  async (): Promise<ContentPrivacyAndTerms> => {
    return await instance.get(ApiRoutesContent.PrivacyAndTerms);
  };
